import { jwtDecode } from "jwt-decode";

export const checkTokenExpiration = (token: string): boolean => {
  try {
    const decoded: any = jwtDecode(token);
    const expirationTime = decoded.exp * 1000; // Convert to milliseconds
    const currentTime = Date.now();
    
    if (expirationTime < currentTime) {
      localStorage.removeItem("token");
      alert("Token has expired. Please log in again.");
      window.location.replace("/Login");
      return true; // Token is expired
    }
    return false; // Token is valid
  } catch (error) {
    localStorage.removeItem("token");
    alert("Invalid token. Please log in again.");
    window.location.replace("/Login");
    return true;
  }
};